"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Graphic = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const super_ellipse_1 = require("@alfalab/core-components/icon-view/super-ellipse");
const system_message_1 = require("@alfalab/core-components/system-message");
const index_module_css_1 = __importDefault(require("./index.module.css"));
exports.Graphic = (0, react_1.memo)(({ graphicBottomAddon, graphicTopAddon, image, Icon, iconClassName, iconBackgroundColor, }) => {
    if (image) {
        return ((0, jsx_runtime_1.jsx)(system_message_1.SystemMessage.Graphic, { className: index_module_css_1.default.component, children: (0, jsx_runtime_1.jsx)("img", { className: iconClassName, src: image, width: '100%', alt: '\u0424\u043E\u043D \u0441\u0438\u0441\u0442\u0435\u043C\u043D\u043E\u0433\u043E \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F' }) }));
    }
    if (Icon) {
        return ((0, jsx_runtime_1.jsx)(system_message_1.SystemMessage.Graphic, { className: index_module_css_1.default.component, children: (0, jsx_runtime_1.jsx)(super_ellipse_1.SuperEllipse, { backgroundColor: iconBackgroundColor, className: (0, classnames_1.default)(iconClassName, {
                    [index_module_css_1.default.defaultBGColor]: !iconBackgroundColor,
                }), topAddons: graphicTopAddon, bottomAddons: graphicBottomAddon, size: 80, children: (0, jsx_runtime_1.jsx)(Icon, { className: index_module_css_1.default.icon }) }) }));
    }
    return null;
});
exports.Graphic.displayName = 'Graphic';
